import React from "react";
import { Formik, FormikProps } from "formik";
import { Values } from "@src/Tools/Values";
import { Grid } from "@material-ui/core";
import { IValuesStore } from "@src/Stores/Values/types";
import _ from "lodash";
import * as Yup from "yup";
import { inject } from "mobx-react";
import { IManagementStore } from "@src/Stores/Management/types";
import { STButton, STFieldWrapper, STButtonGrid } from "./styles";
import { ISystemSettings } from "@src/Interfaces/Entity/SystemSettings";
import NumberField from "@src/Components/Ui/NumberField";
import { IAuthStore } from "@src/Stores/Auth/types";

const schema = Yup.object().shape({
  maxActiveUsers: Yup.number()
    .required(() => Values.getLocalizationValue("fieldIsRequired"))
    .positive(() => Values.getLocalizationValue("fieldPositive")),
});

interface IProps {
  initialValues: ISystemSettings;
  management?: IManagementStore;
  values?: IValuesStore;
  auth?: IAuthStore;
}

@inject("auth", "management", "values")
export default class LimitsForm extends React.Component<IProps> {
  handleSubmit = async (values: ISystemSettings) => {
    await this.props.management.saveSystemSettings(values);
  };

  render() {
    return (
      <Formik
        initialValues={this.props.initialValues}
        validationSchema={schema}
        onSubmit={this.handleSubmit}
        render={(formikProps: FormikProps<ISystemSettings>) => (
          <form onSubmit={formikProps.handleSubmit}>
            <Grid container justify="center" alignContent="center">
              <Grid item xs={9}>
                <STFieldWrapper>
                  <NumberField
                    fieldName="maxActiveUsers"
                    label={Values.getLocalizationValue("maxActiveUser")}
                    formikProps={formikProps}
                    disabled={!this.props.auth.user.location.primary}
                  />
                </STFieldWrapper>
              </Grid>

              <STButtonGrid item xs={9}>
                {this.props.auth.user.location.primary && (
                  <STButton type="submit" variant="contained" color="primary">
                    {Values.getLocalizationValue("update")}
                  </STButton>
                )}
              </STButtonGrid>
            </Grid>
          </form>
        )}
      />
    );
  }
}
